import './scripts/common';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

// Todo: Add page specific JS here e.g:
// Replaced import from package temporarily until the package got fixed
// import * as lightbox from '@elements/lightbox';
import * as lightbox from './libs/@elements/lightbox';
lightbox.init();

import * as scrollSlider from './scripts/scroll-slider';
scrollSlider.init();

import * as video from './scripts/video';
video.init();

import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init();

import * as formValidation from '@elements/form-validation';
formValidation.init({
    trigger: {event: 'false'}
});

import * as paginationScroll from './scripts/pagination-scroll';
paginationScroll.init();